import { render } from "./MyCourese.vue?vue&type=template&id=803afec0&scoped=true"
import script from "./MyCourese.vue?vue&type=script&lang=js"
export * from "./MyCourese.vue?vue&type=script&lang=js"

import "./MyCourese.vue?vue&type=style&index=0&id=803afec0&lang=less&scoped=true"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-803afec0"]])

export default __exports__